// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Fs-z","tooltipWrapper":"Gs-z","icon":"Hs-z","tooltip":"Is-z","content":"Js-z"};